export default '/static/frontend/ReachDigital/12gobiking/dist/assets/pay-later-10b9f965.png'